module.exports = __webpack_public_path__ + "img/7d2a30c067f09360eac7f4cb7f8019e8.png";